import { render, staticRenderFns } from "./ProtocolForm.vue?vue&type=template&id=1df56145"
import script from "./ProtocolForm.vue?vue&type=script&lang=js"
export * from "./ProtocolForm.vue?vue&type=script&lang=js"
import style0 from "./ProtocolForm.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports